<template>
  <div class="detailed-table">
    <div class="table-top clearfix">
      <a-button
        type="primary"
        @click="handleCreateNew"
      >
        创建清单
      </a-button>
      <a-input-search
        placeholder="输入清单名称搜索"
        class="fr"
        :kwd="kwd"
        @search="onSearch"
      />
    </div>
    <a-table
      v-if="!loading"
      row-key="id"
      :columns="columns"
      :data-source="listDatas"
      :pagination="false"
      :locale="{
        'emptyText': '暂无数据'
      }"
      @change="handleTableChange"
    >
      <template
        slot="uptime"
        slot-scope="text,record"
      >
        <div class="input_time">
          <p class="name">
            {{ record.truename || '--' }}
          </p>
          <p class="time fs-gray">
            {{ text }}
          </p>
        </div>
      </template>
      <div
        slot="action"
        slot-scope="text, record"
        class="action"
      >
        <a @click="handleEdit(record)">编辑</a>
        <a @click="handleDelete(record)">删除</a>
      </div>
    </a-table>
    <pagination
      v-if="listDatas && listDatas.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
    <create-new-modal
      :visible.sync="showCreateNewModal"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from '@/components/pc/Pagination'
import CreateNewModal from './CreateNewModal'

export default {
  name: 'DetailedTable',
  components: {
    Pagination,
    CreateNewModal
  },
  data () {
    return {
      kwd: '',
      showCreateNewModal: false
    }
  },

  computed: {
    ...mapState('edm/detailedList', ['loading', 'listDatas', 'pagination', 'tableSort']),
    ...mapGetters('edm/detailedList', ['columns']),
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    }
  },

  watch: {
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize
      this.getList()
    }
  },

  created () {
    this.pagination.currentPage = this.currentPage
    this.pagination.pageSize = this.pageSize
    this.getList()
  },

  methods: {
    ...mapActions('edm/detailedList', ['fetchContact', 'delContact']),
    ...mapMutations('edm/detailedList', ['SET_TABLE_SORT']),

    handleCreateNew () {
      this.showCreateNewModal = true
    },

    reGetList (kwd = '') {
      this.pagination.currentPage = 1
      this.pagination.pageSize = 10
      this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
      this.kwd = kwd
      this.$router.push({
        query: {
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          ...this.tableSort,
          _t: new Date().getTime()
        }
      })
    },

    onSearch (value) {
      this.kwd = value
      this.reGetList(value)
    },

    getList (obj = {}) {
      let params = {}
      let tableSort = this.tableSort
      tableSort.sortkey && Object.assign(params, { sortkey: tableSort.sortkey })
      tableSort.sorttype && Object.assign(params, { sort: tableSort.sorttype })

      params.kwd = this.kwd
      params.page = this.pagination.currentPage
      params.limit = this.pagination.pageSize

      params = Object.assign(params, obj)
      this.fetchContact(params)
    },
    handleTableChange (pagination, filters, sorter) {
      // console.log(sorter)
      const { order, columnKey } = sorter
      let tableSort = {}
      if (sorter.order) {
        let sort = 0
        if (order === 'ascend') {
          sort = 1 // 正序
        } else if (order === 'descend') {
          sort = 2 // 倒序
        } else {
          sort = 0
        }

        tableSort = {
          sortkey: columnKey,
          sorttype: sort
        }
        this.SET_TABLE_SORT({ tableSort, sorter })
      } else {
        tableSort = {
          sortkey: undefined,
          sorttype: undefined
        }
        this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
      }
      this.$router.push({
        name: 'DetailedList',
        query: {
          ...this.$route.query,
          page: 1,
          ...tableSort,
          _t: new Date().getTime()
        }
      })
    },
    handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize,
          ...this.tableSort
        }
      })
    },

    /**
     * 删除邮件
     */
    async handleDelete (record) {
      this.$confirm({
        title: '删除清单',
        content: '删除后发往该清单的排期邮件将无法正常发送，已发送的邮件不受影响，确定要删除吗？',
        closable: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        class: 'confirm-warn-modal del-email-modal',
        onOk: async () => {
          const chain = await this.delContact({ id: record.id })
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                this.getList()
              }
            })
        }
      })
    },
    handleEdit (record) {
      this.$router.push({
        name: 'EditContactList',
        params: {
          contactid: record.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.ant-input-search {
  width: 240px;
}
.ant-table-wrapper {
  margin-top: 24px;
}
.action {
  word-break: keep-all;
  a {
    margin-right: 16px;
    color: #5077aa;
  }
}
.input_time {
  font-size: 12px;
  position: absolute;
  top: 8px;
  line-height: 16px;
}
</style>
